"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getAllFeatures_1 = require("./getAllFeatures");
/**
 * An editor plugin to handle content edit event.
 * The following cases are included:
 * 1. Auto increase/decrease indentation on Tab, Shift+tab
 * 2. Enter, Backspace on empty list item
 * 3. Enter, Backspace on empty blockquote line
 * 4. Auto bullet/numbering
 * 5. Auto link
 * 6. Tab in table
 * 7. Up/Down in table
 * 8. Manage list style
 */
var ContentEdit = /** @class */ (function () {
    /**
     * Create instance of ContentEdit plugin
     * @param settingsOverride An optional feature set to override default feature settings
     * @param additionalFeatures Optional. More features to add
     */
    function ContentEdit(settingsOverride, additionalFeatures) {
        this.settingsOverride = settingsOverride;
        this.additionalFeatures = additionalFeatures;
    }
    /**
     * Get a friendly name of  this plugin
     */
    ContentEdit.prototype.getName = function () {
        return 'ContentEdit';
    };
    /**
     * Initialize this plugin
     * @param editor The editor instance
     */
    ContentEdit.prototype.initialize = function (editor) {
        var _this = this;
        var features = [];
        var allFeatures = getAllFeatures_1.default();
        Object.keys(allFeatures).forEach(function (key) {
            var feature = allFeatures[key];
            var hasSettingForKey = _this.settingsOverride && _this.settingsOverride[key] !== undefined;
            if ((hasSettingForKey && _this.settingsOverride[key]) ||
                (!hasSettingForKey && !feature.defaultDisabled)) {
                features.push(feature);
            }
        });
        features
            .concat(this.additionalFeatures || [])
            .forEach(function (feature) { return editor.addContentEditFeature(feature); });
    };
    /**
     * Dispose this plugin
     */
    ContentEdit.prototype.dispose = function () { };
    return ContentEdit;
}());
exports.default = ContentEdit;
//# sourceMappingURL=ContentEdit.js.map